import React from 'react';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const DONATE_GREEN = '#477C2E';
const DONATE_GREEN_HOVER = '#3d6a27';

/**
 * Pill-shaped "Donate Now" button (dark forest green, white cursive script, soft shadow).
 * Used across header, heroes, and campaign cards for consistency.
 */
const DonateNowButton = ({ onClick, to = '/campaigns', size = 'medium', sx = {} }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onClick) onClick();
    else navigate(to);
  };

  const isSmall = size === 'small';
  const isHeader = size === 'header';
  const height = isHeader ? 60 : isSmall ? 40 : 50;
  const fontSize = isHeader ? 20 : isSmall ? 16 : 22;
  const minWidth = isHeader ? 180 : isSmall ? 100 : 144;

  return (
    <Button
      variant="contained"
      disableElevation
      onClick={handleClick}
      sx={{
        minWidth,
        height,
        borderRadius: 9999,
        backgroundColor: DONATE_GREEN,
        color: '#FFFFFF',
        padding: 0,
        px: isSmall ? 2.5 : 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
        '&:hover': { backgroundColor: DONATE_GREEN_HOVER, boxShadow: '0 6px 18px rgba(0,0,0,0.3)' },
        ...sx,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontFamily: '"Caveat", cursive',
          fontWeight: 700,
          fontSize,
          letterSpacing: '0.02em',
          color: 'inherit',
          whiteSpace: 'nowrap',
        }}
      >
        Donate Now
      </Typography>
    </Button>
  );
};

export default DonateNowButton;
